import { render, staticRenderFns } from "./ForgotPasswordOtp.vue?vue&type=template&id=fd0234d0&"
import script from "./ForgotPasswordOtp.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports